import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title"><span className="highlight">Ben Homer</span></h1>
            <p className="hero-description">
              I'm a student at the University of Utah getting a Bachelors Degree in Software Development.
              Passionate about making software that is Human Centered and User Friendly.
            </p>
            <div className="hero-buttons">
              <a href="#projects" className="btn btn-secondary">View My Work</a>
              <a href="#contact" className="btn btn-secondary">Get In Touch</a>
            </div>
          </div>
          <div className="hero-image">
            <img 
              src="/ProfilePic.jpg" 
              alt="Ben Homer" 
              className="profile-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
